import { ExtensionTrustSettingsService } from '../../service/extension-trust-settings.service';
import { RevokeTrustBtnData } from '../../service/luigiConfig/custom-message-listeners/revoke-trust-btn-data';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnChanges,
  TemplateRef,
  inject,
  input,
} from '@angular/core';
import {
  ButtonBarComponent,
  ButtonComponent,
  ContentDensityDirective,
  MessageToastService,
} from '@fundamental-ngx/core';
import {
  DialogBodyComponent,
  DialogComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogService,
  DialogTemplateDirective,
} from '@fundamental-ngx/core/dialog';
import { IconComponent } from '@fundamental-ngx/core/icon';
import { TitleComponent } from '@fundamental-ngx/core/title';

@Component({
  selector: 'app-revoke-extension-trust-button',
  imports: [
    ButtonComponent,
    ContentDensityDirective,
    TitleComponent,
    DialogTemplateDirective,
    DialogFooterComponent,
    DialogComponent,
    ButtonBarComponent,
    DialogBodyComponent,
    DialogHeaderComponent,
    IconComponent,
  ],
  templateUrl: './revoke-extension-trust-button.component.html',
  styleUrl: './revoke-extension-trust-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RevokeExtensionTrustButtonComponent implements OnChanges {
  confirmationReason = '';
  enableTrustButton = false;
  trustService = inject(ExtensionTrustSettingsService);
  messageToastService = inject(MessageToastService);

  readonly revokeTrustBtnData = input.required<RevokeTrustBtnData>();

  constructor(
    private _dialogService: DialogService,
    private _cdr: ChangeDetectorRef,
  ) {}

  // Changes to the input also trigger ngOnChanges so the trust service will be set when we pass the input in the luigi config.
  public ngOnChanges() {
    const trustData = this.revokeTrustBtnData();
    this.trustService.setTrustData(trustData);
    if (trustData) {
      this.enableTrustButton = this.trustService.isTrusted(trustData.projectId);
    }
  }

  public revokeTrust(dialog: any) {
    dialog.close('Continue');
    this.trustService.revokeTrust();
    const trustData = this.revokeTrustBtnData();
    if (trustData) {
      this.enableTrustButton = this.trustService.isTrusted(trustData.projectId);
    }
    this.openFromString();
  }

  openFromString(): void {
    const content = 'Access revoked. Custom extensions have been disabled.';
    this.messageToastService.open(content, {
      duration: 5000,
    });
  }

  openDialog(dialog: TemplateRef<any>): void {
    const dialogRef = this._dialogService.open(dialog, {
      responsivePadding: true,
      ariaLabelledBy: 'fd-dialog-header-tpl',
      ariaDescribedBy: 'fd-dialog-body-tpl',
      focusTrapped: true,
    });

    dialogRef.afterClosed.subscribe({
      next: (result) => {
        this.confirmationReason = 'Dialog closed with result: ' + result;
        this._cdr.detectChanges();
      },
      error: (error) => {
        this.confirmationReason = 'Dialog dismissed with result: ' + error;
        this._cdr.detectChanges();
      },
    });
  }
}
